module.exports = __webpack_public_path__ + "img/logo_atlantis.865a9602.png";